import { SiteStore } from '@wix/wixstores-client-storefront-sdk';
import { TrackEventName } from '@wix/wixstores-client-core';
import { CartV1 } from './current-cart-service/types';

export class AnalyticsServiceV1 {
  private readonly siteStore: SiteStore;
  constructor({ siteStore }: { siteStore: SiteStore }) {
    this.siteStore = siteStore;
  }

  public trackRemoveLineItemV1({
    lineItemId,
    updatedCart,
    previousCart,
  }: {
    lineItemId: string;
    updatedCart: CartV1;
    previousCart: CartV1;
  }) {
    const lineItem = previousCart.lineItems!.find(
      ({ _id }) => _id === lineItemId,
    );
    this.siteStore.trackEvent(TrackEventName.REMOVE_FROM_CART, {
      id: lineItem!.catalogReference?.catalogItemId,
      name: lineItem!.productName?.original,
      price: lineItem!.price?.amount,
      quantity: lineItem!.quantity,
      sku: lineItem!.physicalProperties?.sku,
      currency: updatedCart.currency,
    });
  }
}
